export default __webpack_public_path__ + "i18n/it.242cdbeeafefe3cb361645aa21c9b316.json";